import { BarChart, Check, Coins, PiggyBank } from "lucide-react";
import {
  filterCurrentMonthOnwards,
  getAggregateEarned,
  getCurrencyFormatted,
  getPaid,
  getUnapproved,
} from "@/lib/app";
import { getCommissionsValue } from "@revelate/calc";
import { NestedCommission } from "@revelate/types";
import { Database } from "@revelate/types/supabase";
import { StatCard } from "./stat-card";

interface CommissionKeyValuesProps {
  commissions: NestedCommission[];
  projectedCommissions: NestedCommission[];
  companyCurrency: Database["public"]["Tables"]["currencies"]["Row"] | null;
  showCards?: Array<"earned" | "forecasted" | "unapproved" | "paid">; // Any 2 expected
}

export function CommissionKeyValues({
  commissions,
  projectedCommissions,
  companyCurrency,
  showCards = ["earned", "forecasted"],
}: CommissionKeyValuesProps) {
  return (
    <div className="grid gap-4 grid-cols-2">
      {showCards.includes("earned") && (
        <StatCard title="Earned commission" icon={Coins}>
          {getCurrencyFormatted(
            getCommissionsValue(getAggregateEarned(commissions)),
            companyCurrency?.code
          )}
        </StatCard>
      )}

      {showCards.includes("forecasted") && (
        <StatCard title="Total forecasted commission" icon={BarChart}>
          {getCurrencyFormatted(
            getCommissionsValue(
              filterCurrentMonthOnwards(projectedCommissions)
            ) + getCommissionsValue(getAggregateEarned(commissions)),
            companyCurrency?.code
          )}
        </StatCard>
      )}

      {showCards.includes("unapproved") && (
        <StatCard title="Commissions to approve" icon={Check}>
          {getCurrencyFormatted(
            getCommissionsValue(getUnapproved(commissions)),
            companyCurrency?.code
          )}
        </StatCard>
      )}

      {showCards.includes("paid") && (
        <StatCard title="Paid commission" icon={PiggyBank}>
          {getCurrencyFormatted(
            getCommissionsValue(getPaid(commissions)),
            companyCurrency?.code
          )}
        </StatCard>
      )}
    </div>
  );
}
